<template>
  <div id="cars">
    <h2 class="div-transparent">Nabídka</h2>
    <Spinner v-show="isCarsLoading" />
    <transition name="cars-expand">
      <div class="car-cards" v-show="!isCarsLoading">
        <CarCard v-for="(car, index) in cars" :carData="car" :key="index"></CarCard>
      </div>
    </transition>
  </div>
</template>
<script>
import CarCard from "./CarCard";
import Spinner from "../../../UI/Spinner";

export default {
  components: {
    CarCard,
    Spinner
  },
  computed: {
    cars() {
      return this.$store.getters.getCars;
    },
    isCarsLoading() {
      return this.$store.getters.isCarsLoading;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";

#cars {
  position: relative;
  background-color: $default-page-background;
  min-height: 30rem;
  .car-cards {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0;
  }
  .cars-expand-enter-active {
    animation: none;
  }
  @media (min-width: $min-width-extended) {
    .car-cards {
      padding: 0 5%;
    }
    .cars-expand-enter-active {
      animation: expand 1s ease-out forwards;

      @keyframes expand {
        0% {
          transform: scaleY(0);
        }
        100% {
          transform: scaleY(1);
        }
      }
    }
  }
}
</style>
